import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import moment from 'moment';

import { defaultDateFormat } from 'Common/GeneralHelper';
import { Filter, Main } from 'Containers/';
import { LoadingPage, TitledCard } from 'Components/';
import SelectSitesTable from 'Common/SelectSitesTable';
import { ReportGeneration } from 'Common/ObjectHelper';
import { toastType, createToast, toastError } from 'Common/ToastHelper';
import { RevenueSummaryReportForm } from './components/RevenueSummaryReportForm';
import { REVENUE_SUMMARY_REPORT_FORM_NAME } from 'Common/FormEnum';
import { RevenueSummaryReportFieldEnum as Fields } from 'Common/FieldEnum';
import {
  getReimbursementRates,
  getRevenueSummaryReport,
  clearReport,
} from './state/report/actions';

class RevenueSummaryReportContainer extends Component {
  state = {
    selectedSites: [],
  };

  handleSubmit = formValues => {
    if (this.state.selectedSites.length === 0) {
      toastError('You must select at least one site');
      return;
    }
    // The Form and sites table are seperate, so they are combined into one object
    const values = { ...formValues, selectedSites: this.state.selectedSites };
    this.props.getRevenueSummaryReport(values);
  };

  onSiteChange = values => {
    this.setState({
      selectedSites: values,
    });
  };

  getMainProps = () => {
    const { loading } = this.props;
    return {
      toolbox: {
        formName: REVENUE_SUMMARY_REPORT_FORM_NAME,
        saveButtonProps: {
          content: 'View',
          loading: loading,
          disabled: loading,
        },
        shown: true,
      },
    };
  };

  componentDidMount() {
    this.props.getReimbursementRates();
  }

  componentDidUpdate(prevProps, prevState) {
    const { report } = this.props;
    if (report && prevProps.report !== report) {
      if (report === 'No Data') {
        createToast(toastType.info, 'Results', 'No data found!', true);
      } else {
        ReportGeneration(report, 'Revenue Summary Report');
      }
      this.props.clearReport();
    }
  }

  render() {
    const { reimbursementRates } = this.props;
    return (
      <Fragment>
        {this.props.fetching ? <LoadingPage /> : undefined}
        <Filter title={'Revenue Summary Report'} />
        <Main {...this.getMainProps()}>
          <TitledCard title={'Filters'}>
            <RevenueSummaryReportForm
              rates={reimbursementRates}
              onSubmit={this.handleSubmit}
              initialValues={{
                [Fields.IsSupper]: 0,
                [Fields.FromDate]: defaultDateFormat(moment()),
                [Fields.ToDate]: defaultDateFormat(moment()),
              }}
            />
          </TitledCard>
          <TitledCard title={'Sites'}>
            <SelectSitesTable onChange={this.onSiteChange} />
          </TitledCard>
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const { revenueSummaryReport } = state.RevenueSummaryReportState;
  return {
    fetching: revenueSummaryReport.fetching,
    report: revenueSummaryReport.report,
    reimbursementRates: revenueSummaryReport.reimbursementRates,
    selectedSites: revenueSummaryReport.selectedSites,
  };
};

export const RevenueSummaryReport = withRouter(
  connect(
    mapStateToProps,
    {
      getReimbursementRates,
      getRevenueSummaryReport,
      clearReport,
    }
  )(RevenueSummaryReportContainer)
);



// WEBPACK FOOTER //
// ./src/pages/revenuesummaryreport/RevenueSummaryReport.js